import React from "react";
import { Row, Col, Tooltip } from "antd";
import PropTypes from 'prop-types';
import Heading from "../../../RecommendGrant/Component/ViewEditSchedules/Components/Heading";
import InfoBlock from "../../../RecommendGrant/Component/ViewEditSchedules/Components/InfoBlock";
import { BoxDetailWrapper } from "../../../RecommendGrant/Component/ViewEditSchedules/style";
import {
  UnderlyingContent,
} from "../../../RecommendGrant/style";
import PurposeSummary from "../../../../Components/PurposeSummary/PurposeSummary";
import getRecognitionRender from "../../../RecommendGrant/Component/ViewEditSchedules/Components/ViewRecognition";

const getPurposeComments = (purpose,index) =>
purpose.additionalComments ||
purpose.projectName ||
purpose.eventName ||
purpose.missionaryName ||
purpose.missionaryLocation ? (
  <>
    <Tooltip
      className="grantsFlow"
      placement="bottomLeft"
      trigger={window.innerWidth < 992 ? "click" : "hover"}
      title={() => <PurposeSummary {...purpose} />}
    >
      <UnderlyingContent id={`${purpose.purposeName}anrPurposeName${index}`}>
        {purpose.purposeName}
      </UnderlyingContent>
    </Tooltip>
  </>
) : (
  <>
    <Tooltip
      className="grantsFlow"
      placement="bottomLeft"
      trigger={window.innerWidth < 992 ? "click" : "hover"}
      title={() => <PurposeSummary {...purpose} />}
    >
      <UnderlyingContent id={`${purpose.purposeName}anrAgreementFlowPurposeName${index}`}>
        {purpose.purposeName}
      </UnderlyingContent>
    </Tooltip>
  </>
);

const getAdditionalAttrRender = (purposeRecognition) => {
  const twoSections =
    purposeRecognition.notifyName &&
    (purposeRecognition.inMemoryOfName || purposeRecognition.inHonorOfName);
  return (
    <>
      {purposeRecognition.notifyName && (
        <Col span={twoSections ? 12 : 24}>
          <InfoBlock
            title="Please Notify"
            breakAll
            value={purposeRecognition.notifyName}
            confirmationPage
          />
        </Col>
      )}
      {(purposeRecognition.inMemoryOfName ||
        purposeRecognition.inHonorOfName) && (
        <Col span={twoSections ? 11 : 24} offset={twoSections && 1}>
          <InfoBlock
            title="Additional Attribution"
            breakAll
            value={purposeRecognition.inMemoryOfName}
            value2={purposeRecognition.inHonorOfName}
            confirmationPage
          />
        </Col>
      )}
    </>
  );
};

export default function PurposeRecognition({ purposeRecognition = {} }) {
  return (
    <Row>
      <Col xs={0} md={0} lg={24}>
        <Row>
          <Col span={14}>
            <Heading
              title={purposeRecognition.title}
              edit={purposeRecognition.edit}
              handleEdit={purposeRecognition.handleEdit}
              id="btnpurposeRecognitionEdit"
            />
          </Col>
        </Row>
        <Row type="flex">
          <BoxDetailWrapper border span={14}>
            <InfoBlock
              border
              title="Purpose"
              value={getPurposeComments(purposeRecognition,1)}
            />
          </BoxDetailWrapper>
        </Row>
        <Row type="flex">
          <BoxDetailWrapper
            border-={
              purposeRecognition.notifyName ||
              purposeRecognition.inMemoryOfName ||
              purposeRecognition.inHonorOfName
            }
            span={14}
          >
            <InfoBlock
              border
              title="Grant Recognition"
              value={getRecognitionRender(
                purposeRecognition.grantRecognition,
                purposeRecognition.advisors,
                purposeRecognition.thirdParty,
                purposeRecognition.includeAdvisorInfo
              )}
            />
          </BoxDetailWrapper>
        </Row>
        {(purposeRecognition.notifyName ||
          purposeRecognition.inMemoryOfName ||
          purposeRecognition.inHonorOfName) && (
          <Row type="flex">
            <BoxDetailWrapper span={14}>
              {getAdditionalAttrRender(purposeRecognition)}
            </BoxDetailWrapper>
          </Row>
        )}
      </Col>
      <Col md={24} xs={24} lg={0}>
        <Heading
          title={purposeRecognition.title}
          edit={purposeRecognition.edit}
          handleEdit={purposeRecognition.handleEdit}
          id="btnpurposeRecognitionEdit2"
        />
        <BoxDetailWrapper border>
          <InfoBlock
            border
            title="Purpose"
            value={getPurposeComments(purposeRecognition,2)}
          />
        </BoxDetailWrapper>
        <BoxDetailWrapper
          border={
            purposeRecognition.notifyName ||
            purposeRecognition.inMemoryOfName ||
            purposeRecognition.inHonorOfName
          }
        >
          <InfoBlock
            border={
              purposeRecognition.notifyName ||
              purposeRecognition.inMemoryOfName ||
              purposeRecognition.inHonorOfName
            }
            title="Grant Recognition"
            value={getRecognitionRender(
              purposeRecognition.grantRecognition,
              purposeRecognition.advisors,
              purposeRecognition.thirdParty,
              purposeRecognition.includeAdvisorInfo
            )}
          />
        </BoxDetailWrapper>
        {(purposeRecognition.notifyName ||
          purposeRecognition.inMemoryOfName ||
          purposeRecognition.inHonorOfName) && (
          <BoxDetailWrapper>{getAdditionalAttrRender(purposeRecognition)}</BoxDetailWrapper>
        )}
      </Col>
    </Row>
  );
}

PurposeRecognition.propTypes = {
  purposeRecognition: PropTypes.object
}
